'use es6';

export const evaluateLinearEquation = (equationObj, variableValues, indexValues) => {
  const {
    columnStepDistanceWidth,
    rowStepDistanceHeight,
    deepestColumnStepDistanceWidth,
    deepestRowStepDistanceHeight,
    value
  } = equationObj;
  if (value) {
    return value;
  }
  const {
    currentRowAndColumnIndex,
    isDeepestRowAndColumnIndex
  } = indexValues;
  const {
    width,
    height
  } = variableValues;
  let distance;
  if (columnStepDistanceWidth != null) {
    if (isDeepestRowAndColumnIndex) {
      // We account for a larger buffer percentage if we're looking at the deepest nested column
      // (per: https://git.hubteam.com/HubSpot/ContentEditorUI/issues/7146)
      // Note: We subtract one because we need to calculate the buffer distance for the columns
      // leading up to the parent column.
      distance = deepestColumnStepDistanceWidth * width + columnStepDistanceWidth * width * (currentRowAndColumnIndex - 1);
    } else {
      distance = columnStepDistanceWidth * width * currentRowAndColumnIndex;
    }
  }
  if (rowStepDistanceHeight != null) {
    if (isDeepestRowAndColumnIndex) {
      // We account for a larger buffer percentage if we're looking at the deepest nested row
      // (per: https://git.hubteam.com/HubSpot/ContentEditorUI/issues/7146)
      // Note: We subtract one because we need to calculate the buffer distance for the rows
      // leading up to the parent row.
      distance = deepestRowStepDistanceHeight * height + rowStepDistanceHeight * height * (currentRowAndColumnIndex - 1);
    } else {
      distance = rowStepDistanceHeight * height * currentRowAndColumnIndex;
    }
  }
  return distance;
};